module.exports = __webpack_public_path__ + "static/img-9-8c6c9c8e74e98e240460495a3bd8eb8f.jpg";